export class SplashManager {
    static setText(text: string) {
        if (typeof document === 'undefined') return;
        const el = document.getElementById('splash-text');
        if (el) el.textContent = text;
    }

    static setProgress(value: number) {
        if (typeof document === 'undefined') return;
        const bar = document.getElementById('splash-progress');
        if (bar) bar.style.width = value + '%';
    }

    static hide() {
        if (typeof document === 'undefined') return;
        document.body.classList.add('splash-hide');
    }
}
